<template>
  <div>
    <div>
      <p>{{ messageBody }}</p>
    </div>

    <div text-center>
      <a @click="onConfirmClick" class="btn btn-primary">{{ i18n.app.common.close }}</a>
    </div>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js";

export default {
  name: "simple-dialog",
  mixins: [DialogMixin],
  mounted() {},
  methods: {
    onConfirmClick() {
      this.proceed(); // included in DialogMixin
    },
    onCancelClick() {
      this.cancel(); // included in DialogMixin
    }
  }
};
</script>
